import { Injectable } from '@angular/core';
import { Observable, catchError, of } from 'rxjs';

import { VlaioHttpClientService } from '@vlaio/shared/core';
import { RequestSuccessResultEntity } from '@vlaio/shared/types';

import { SelfRegistrationApplicationEndpoints } from '../endpoints';
import { ApplicationRequestEntity } from '../interfaces';

@Injectable()
export class ApplicationApiService {
	constructor(private readonly httpClientService: VlaioHttpClientService) {}

	/**
	 * Create a new self-registration application
	 *
	 * @param request - The application request we wish to send
	 */
	public createNewApplication(request: ApplicationRequestEntity): Observable<RequestSuccessResultEntity> {
		return this.httpClientService
			.post<RequestSuccessResultEntity>(SelfRegistrationApplicationEndpoints.Create(), {
				mandaatgever_id: request.giver,
				commentaar: request.comment,
				product_id: request.product
			})
			.pipe(
				catchError((err) => {
					return of({ fouten: [err.error.errorMessage], succes: false });
				})
			);
	}
}
